import { isString } from 'lodash';

import { StorageService } from '@sm360/widget-commons-core-services';

/**
 * Service to handle session storage
 */
class SessionStorageService {
    constructor() {
        this.storage = StorageService.from('sessionstorage');
    }

    /**
     * Get an element of the SessionStorage
     * @param {string} storageKey
     */
    get(storageKey) {
        if (!this.storage || !isString(storageKey)) {
            return null;
        }

        return JSON.parse(this.storage.getItem(storageKey));
    }

    /**
     * Add of update an element in the session storage
     * @param {string} storageKey
     * @param {*} value
     */
    set(storageKey, value) {
        if (!this.storage || !isString(storageKey)) {
            return;
        }

        this.storage.setItem(storageKey, JSON.stringify(value));
    }

    /**
     * Remove an element of the session storage
     * @param {string} storageKey
     */
    delete(storageKey) {
        if (!this.storage || !isString(storageKey)) {
            return;
        }

        this.storage.removeItem(storageKey);
    }
}

export default new SessionStorageService();
